import { FaSearch } from "react-icons/fa";
import { useCityBar } from "./useCityBar";
import { Option } from "./Option";
import React from "react";

export interface Options {
  id: string;
  label: string;
  slug: string;
}

export interface CityBarProps {
  options: Options[];
  onSelect?: (value: string) => void;
  defaultValue?: string;
  className?: string;
  style?: React.CSSProperties;
  onSearch?: (value: string) => void;
  mode?: "normal" | "screen";
  suffixIcon?: React.ReactNode;
}

const CityBar: React.FC<CityBarProps> = (props) => {
  const {
    OnOptionSelect,
    defaultOption,
    setValue,
    setTrigger,
    filters,
    trigger,
    value,
    boxRef,
    onSearch,
    onClickInput,
  } = useCityBar({
    options: props.options,
    onSelect: props.onSelect,
    defaultValue: props.defaultValue,
  });

  return (
    <div
      style={{ zIndex: 9999999 }}
      className="w-full text-white m-0 p-0 rounded-md bg-primary"
    >
      <div
        style={{ ...props.style, mixBlendMode: props.mode }}
        className={props.className + "w-full relative bg-primary rounded-md isolate"}
        ref={boxRef}
        onClick={() => {
          if (!trigger) setTrigger(true);
        }}
      >
        <div className="flex justify-center items-center p-2 relative cursor-text rounded-md">
          <input
            onClick={onClickInput}
            placeholder=""
            aria-label="Select City"
            title="Select City"
            className="city-input"
            value={value}
            onBlur={() => {
              setValue("");
            }}
            onChange={(e) => {
              props.onSearch?.(e.currentTarget.value);
              onSearch(e);
            }}
          />

          <span className="flex-1 p-0 m-0">{defaultOption.label}</span>
          {props.suffixIcon ? props.suffixIcon : <FaSearch />}
        </div>
        {trigger && (
          <div style={{ zIndex: 9999999 }} className="drop-down">
            {filters.map((option) => (
              <Option
                active={defaultOption.slug === option.slug}
                key={option.id}
                label={option.label}
                value={option.slug}
                onClick={(value) => OnOptionSelect(value, option)}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

CityBar.defaultProps = {
  mode: "normal",
};

export default CityBar;
